import { Component } from '@angular/core';
import { detectBody } from '../../../app.helpers';

declare var jQuery:any;

@Component({
  selector: 'admin',
  templateUrl: 'adminLayout.template.html',
  host: {
    '(window:resize)': 'onResize()'
  }
})
export class AdminLayoutComponent {

  public ngOnInit():any {
    detectBody();
  }

  public onResize(){
    detectBody();
  }

}
